import { umbracoApi } from "./UmbracoApi";

export const getContentByUrl = async (uri) => {
  let _response = {};
  try {
    const { data, error } = await umbracoApi.get(`/url?url=${uri}`);
    _response = {
      ..._response,
      data,
      error,
    };
  } catch (err) {
    const response = (err.response && err.response.data) || {};
    _response = {
      ..._response,
      data: response.data,
      error: response.error || err,
    };
  }

  return _response;
};

export const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};
